import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Sparkles, CheckCircle2 } from "lucide-react";

const SUBSCRIPTION_OK_DELAY_MS = 5000;

export const SubscriptionConfirmationPage = (): JSX.Element => {
    const navigate = useNavigate();
    const notifiedRef = useRef(false);
    const [countdown, setCountdown] = useState(
        Math.ceil(SUBSCRIPTION_OK_DELAY_MS / 1000)
    );

    const notifyOpener = () => {
        if (notifiedRef.current) return;
        notifiedRef.current = true;
        if (window.opener) {
            window.opener.postMessage({ type: "SUBSCRIPTION_OK" }, "*");
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCountdown((prev) => Math.max(0, prev - 1));
        }, 1000);
        const timer = setTimeout(() => {
            notifyOpener();
            clearInterval(interval);
            if (window.opener) {
                window.close();
            }
        }, SUBSCRIPTION_OK_DELAY_MS);
        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, []);

    const handleGoHome = () => {
        notifyOpener();
        if (window.opener) {
            window.close();
        } else {
            navigate("/");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-background border border-border rounded-xl shadow-sm p-6">
                {/* Header with Carriapp Plus badge */}
                <div className="flex flex-col items-center text-center mb-6">
                    <Badge
                        variant="default"
                        className="w-fit flex items-center gap-1 text-xs mb-4"
                    >
                        <Sparkles size={10} /> Carriapp Plus
                    </Badge>

                    {/* Success heading with icon */}
                    <div className="flex items-center gap-2 mb-2">
                        <CheckCircle2
                            size={28}
                            className="text-primary shrink-0"
                        />
                        <h1 className="text-2xl font-bold leading-tight text-foreground">
                            ¡Suscripción activada!
                        </h1>
                    </div>

                    {/* Confirmation message */}
                    <p className="text-base text-muted-foreground mt-2">
                        Tu membresía Carriapp Plus está ahora activa. ¡Gracias por confiar en nosotros!
                    </p>
                </div>

                {/* Highlight box */}
                <div className="bg-primary/10 rounded-lg p-3 text-sm font-medium text-center text-primary mb-6">
                    Ya puedes disfrutar de todos los beneficios Plus
                </div>

                {/* Redirect countdown */}
                {countdown > 0 && (
                    <p className="text-xs text-muted-foreground text-center mb-4">
                        Serás redirigido automáticamente en {countdown}s
                    </p>
                )}

                {/* CTA button */}
                <Button
                    variant="default"
                    size="lg"
                    className="w-full"
                    onClick={handleGoHome}
                >
                    Volver a Carriapp
                </Button>
            </div>
        </div>
    );
};
